/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, OnInit} from '@angular/core';
import {completeCopyModal} from '../../common/util/complete-copy-modal';
import {Subject} from 'rxjs';
import {BsModalRef} from 'ngx-bootstrap/modal';
import * as _ from 'lodash';
import {nextCopyTitle} from '../../../components/util/next-copy-title';
import {Uuid} from '../../../components/util/uuid';
import {LayoutIncludeApiService} from './layout-include-api.service';
import {FormsModule} from '@angular/forms';
import {APP_SHARED} from '../../common/app-shared';

export interface LayoutIncludeCopyResult {
  model: any;
  destination: boolean;
}

@Component({
  standalone: true,
  imports: [...APP_SHARED, FormsModule],
  selector: 'adn-layout-include-copy-modal',
  template: `
    <form class="form-horizontal" (ngSubmit)="copy()">
      <div class="modal-header dialogAddStuff">
        <button type="button" class="close" (click)="dismiss()">&times;</button>
        <h4 class="modal-title">
          <span>{{ 'label.copy.layoutInclude' | ogTranslate }}</span>
          <small>{{originalName}}</small>
        </h4>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <label class="col-md-3 control-label">{{ 'label.name' | ogTranslate }}</label>
          <div class="col-md-9">
            <input type="text" class="form-control" name="layoutInclude.name" [(ngModel)]="name" required>
          </div>
        </div>
        <div class="form-group">
          <label class="col-md-3 control-label">{{ 'label.reference' | ogTranslate }}</label>
          <div class="col-md-9">
            <input type="text" class="form-control" name="layoutInclude.reference" [(ngModel)]="reference" pattern="[a-zA-Z0-9_]+" required>
          </div>
        </div>
        <div class="form-group">
          <label class="col-md-3 control-label">{{ 'label.description' | ogTranslate }}</label>
          <div class="col-md-9">
            <input type="text" class="form-control" name="layoutInclude.description" [(ngModel)]="description">
          </div>
        </div>
        <div class="checkbox text-right">
          <label class="checkbox">
            <input type="checkbox" [(ngModel)]="destination" name="layoutInclude.destination">
            <span class="small">Go to new layout include after copy</span>
          </label>
        </div>
      </div>
      <div class="modal-footer">
        <a class="btn btn-link btn-xs" (click)="dismiss()">{{ 'button.cancel' | ogTranslate }}</a>
        <button type="submit" class="btn btn-default">{{ 'label.copy' | ogTranslate }}</button>
      </div>
    </form>
  `
})
export class LayoutIncludeCopyModalComponent implements OnInit {
  /** Set via BsModalService initialState */
  model: any;

  readonly onCopied = new Subject<LayoutIncludeCopyResult>();

  originalName = '';
  name = '';
  reference = '';
  description = '';
  destination = true;

  constructor(
    public bsModalRef: BsModalRef,
    private readonly api: LayoutIncludeApiService
  ) {}

  ngOnInit(): void {
    this.originalName = this.model?.name || '';
    this.name = nextCopyTitle(this.model?.name || '');
    this.reference = (this.model?.reference || '') + '_copy';
    this.description = this.model?.description || '';
  }

  copy(): void {
    const copy = _.cloneDeep({...this.model,
      id: Uuid.generate(),
      name: this.name,
      reference: this.reference,
      description: this.description
    });
    this.api.save(copy).subscribe((saved) => {
      completeCopyModal(this.bsModalRef, this.onCopied, {model: saved, destination: this.destination});
    });
  }

  dismiss(): void {
    this.bsModalRef.hide();
  }
}
